<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-22 17:08:40
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-12 13:53:07
-->
<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
  import { mapState } from 'pinia'
  import { pinias } from '@main/common/pinia'

  const { cachedView } = pinias
  export default {
    name: 'AppMain',
    computed: {
      ...mapState(cachedView, ['cachedViews']),
      key() {
        return this.$route.path
      }
    }
  }
</script>

<style lang="scss" scoped>
  .app-main {
    position: relative;

    // background: #fff;
    box-sizing: border-box;
    width: 100%;

    /* 50= navbar  50  */
    height: calc(100vh - 104px);
    padding: 20px 10px 10px;
    border-radius: 20px;
  }

  .fixed-header + .app-main {
    padding-top: 50px;
  }

  .has-tags-view {
    .app-main {
      /* 84 = navbar + tags-view = 50 + 34 */
      // height: calc(100% - 84px);
      height: 100%;
    }

    .fixed-header + .app-main {
      padding-top: 75px;
    }
  }
</style>

<style lang="scss">
  // fix css style bug in open el-dialog

  .el-popup-parent--hidden {
    .fixed-header {
      // padding-right: 17px;
    }
  }
</style>
